module.exports = "<div *ngIf=\"active\" class=\"loading-overlay\" #spinnerElement>\n  <div></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/spinner/spinner.component.html
// module id = 1137
// module chunks = 1